import React from "react";
import { Link } from 'react-scroll'; // scroll ablilty inspired by https://dev.to/diballesteros/how-to-make-a-navbar-with-react-scroll-4im8
import styles from './PageHeader.module.css'

export default function PageHeader({image, title, description, sections, sectionNames}) {

    //The list of arguments:
    // "image": Has the path to the choosen image for the Pageheader
    // "title": Has the title of the page
    // "description": Has a description of the page. If there is no value, the <p> is not displayed becouse it has a text box that would be empty
    // "gradiant": There is a list of grandiant backgrounds from 1-n at App.css :root, and this argument has the choosen of these
    // "sections": To help getting an overview of the page, a list of the pages sections is display.
    //              section should come as an array in the from: const section = ["section_1", "section_2", "section_n"].
    // "sectionNames": Since the sections cannot have danish letters, and has to be "oneWord" a list of thee display name
    // is added as well, for it to be prettier.

    //              The page should be then be devided in corrosponding:     <section id="section_n"= > 
    //                                                                          * content *
    //                                                                       </section>

    return(
        <div className={styles.pageHeaderWrapper} >
            <div className={styles.pageHeaderImg} style={{ backgroundImage: `url(${image})` }}>
                
            </div>
            <div className={styles.pageHeaderTextBox}>
                <h1 className={styles.pageHeadTitle} >{title}</h1>

                <div className={styles.pageHeaderSectionNav}>
                    {sections && sectionNames && (
                        sectionNames.map((secName, index) => (
                            // this is a Link element from react-scroll, the to='id' scrolls the page to a section with corresponding id
                            <Link 
                                className={styles.pageHeaderSectionBnt} 
                                to={sections[index]} 
                                key={sections[index]}>
                                <p style={{margin: '0px', fontWeight: 700}}> {secName}</p>
                            </Link>
                        ))
                    )} 
                </div>

                {description && (
                <p className={styles.pageHeaderDescription}>{description}</p>
                )}
                
            </div>
        </div>
    );
}